import { apiClient } from '@/api/client';
import type { UserProfileResponse, TeamMemberResponse } from '@/api/types';

export async function getCurrentUser(): Promise<UserProfileResponse> {
  const { data } = await apiClient.get('/api/v1/users/me');
  return data;
}

export async function getTeamMembers(teamId: string): Promise<TeamMemberResponse[]> {
  const { data } = await apiClient.get(`/api/v1/teams/${teamId}/members`);
  return data;
}

export async function getTeams(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>('/api/v1/teams');
  return data;
}
